import React from "react";
import "./../../../../assets/css/Dashboard/ServicesKanban.scss";
import useTitanApp from "../../../../hooks/useTitanApp";
import Popover from "@mui/material/Popover";
import { sortServicesStage } from "../../../../dispatchers/pharmacyServiceDispatchers";

export default function SortingServices({ stageType }) {
  const { appState } = useTitanApp();
  const [anchorEl1, setAnchorEl1] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const [anchorEl3, setAnchorEl3] = React.useState(null);
  const [anchorEl4, setAnchorEl4] = React.useState(null);

  const isOpen = (popoverIndex) => Boolean(getAnchorEl(popoverIndex));

  const getAnchorEl = (popoverIndex) => {
    switch (popoverIndex) {
      case 1:
        return anchorEl1;
      case 2:
        return anchorEl2;
      case 3:
        return anchorEl3;
      case 4:
        return anchorEl4;
      default:
        return null;
    }
  };
  const generatePopoverId = (index) => `simple-popover-${index}`;

  const handleClickOption = (event, popoverIndex) => {
    const setAnchorEl = getSetAnchorElFunction(popoverIndex);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (popoverIndex) => () => {
    const setAnchorEl = getSetAnchorElFunction(popoverIndex);
    setAnchorEl(null);
  };

  const getSetAnchorElFunction = (popoverIndex) => {
    switch (popoverIndex) {
      case 1:
        return setAnchorEl1;
      case 2:
        return setAnchorEl2;
      case 3:
        return setAnchorEl3;
      case 4:
        return setAnchorEl4;
      default:
        return null;
    }
  };

  return (
    <div>
      <button
        onClick={(event) => {
          handleClickOption(event, stageType);
        }}
      >
        <p>...</p>
      </button>

      <Popover
        id={generatePopoverId(stageType)}
        open={isOpen(stageType)}
        anchorEl={getAnchorEl(stageType)}
        onClose={handleClose(stageType)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        className="sorting-popover"
      >
        <p onClick={() => sortServicesStage(stageType, true)}>
          Sort by Date Ascending
        </p>
        <p onClick={() => sortServicesStage(stageType, false)}>
          Sort by Date Descending
        </p>
      </Popover>
    </div>
  );
}
